import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    main: {
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

export default function FrameLoading() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.main}>
      <Typography variant="h5">{t("loading")}</Typography>
    </div>
  );
}
